import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import Helmet from 'react-helmet';
import DigitalStatementsHeader from './DigitalStatementsHeader';
import { DigitalStatementsHelpModal } from './DigitalStatementsHelpModal';
import BrowserUtils from '../../utils/BrowserUtils';
import { BasicModal } from '../common/modals/BasicModal';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import ApiUtils from '../../utils/ApiUtils';
import envConfig from '../../../static/config';
import AccountsStore from '../../stores/AccountsStore';
import {
  GenericChatComponent,
  getChatContent,
} from '../common/GenericChatComponent';
import DigitalStatementsStore from '../../stores/DigitalStatementsStore';
import OrientationSwitch from '../common/OrientationSwitch';
import InternetBankingActions from '../../actions/InternetBankingActions';
import IEPrintIssueModalComponent from './IEPrintIssueModalComponent';
import { backgroundColorMap } from '../../utils/ui-utils';
import { BioCatchContext } from '../BioCatchContext';
import { VIEW_PAYMENT_DETAILS_CONTEXT } from '../../config/BioCatch';
import UserManagementStore from '../../stores/UserManagementStore';

class DigitalStatements extends Component {
  constructor(props) {
    super(props);
    this.helpModal = this.helpModal.bind(this);
    this._errorModal = this._errorModal.bind(this);
    this.getStatementsForSelectedMonth =
      this.getStatementsForSelectedMonth.bind(this);
    this.onMessageReceive = this.onMessageReceive.bind(this);
    this.printStatements = this.printStatements.bind(this);
    this.getPDFName = this.getPDFName.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.digitalStatementsView = this.digitalStatementsView.bind(this);
    this.backToAccountPage = this.backToAccountPage.bind(this);
    this.closeAction = this.closeAction.bind(this); // IE only popupModal
    this.state = {
      accountId: AccountsStore.getAccount(),
      showModal: false,
      errorModal: false,
      toDate: '',
      navigationUrl: DigitalStatementsStore.getNavigationUrlName(),
      showModalForIEPrintIssue: false,
    };
  }
  componentWillMount() {
    window.addEventListener('message', this.onMessageReceive);
    if (envConfig.brandId !== 'VM') {
      document.body.style.backgroundColor =
        backgroundColorMap[envConfig.brandId];
    }
  }
  componentDidMount() {
    DigitalStatementsStore.addChangeListener(this.onStoreChange);
    setTimeout(() => {
      this.getStatementsForSelectedMonth(0);
      this.forceUpdate();
    }, 3000);
  }
  componentDidMount() {
    DigitalStatementsStore.addChangeListener(this.onStoreChange);
    setTimeout(() => {
      this.getStatementsForSelectedMonth(0);
      this.forceUpdate();
    }, 3000);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      errorModal: nextProps.getStatementPreferenceErrorFlag,
    });
  }
  componentWillUnmount() {
    DigitalStatementsStore.removeChangeListener(this.onStoreChange);
    window.removeEventListener('message', this.onMessageReceive);
    document.body.style.backgroundColor = '';
  }
  onMessageReceive(e) {
    if (e.data.error) {
      this.setState({ errorModal: true });
    }
    if (e.data.windowHeight) {
      document.getElementById('statements').style.height = `${
        e.data.windowHeight + 50
      }px`;
      document.getElementById('statements').style.maxHeight = '100%';
    }
  }
  onStoreChange() {
    this.setState({
      navigationUrl: DigitalStatementsStore.getNavigationUrlName(),
    });
  }
  getPDFName() {
    let product = AccountsStore.getAccountDetail(
      this.state.accountId
    ).displayName;
    let pdfName = '';
    product = _.split(product, ' ');
    _.map(product, (product, index) => {
      index === 0
        ? (pdfName = `${product}_`)
        : (pdfName = `${pdfName}${product}_`);
    });
    const productName = `${pdfName}Statement_${moment(this.state.toDate).format(
      'YYYY-MM-DD'
    )}`;
    return productName;
  }

  getStatementsForSelectedMonth(month) {
    try {
      const sender = document.getElementById('statements');
      if (sender) {
        sender.contentWindow.postMessage(
          ApiUtils.setSessionValuesForStatements(month, this.state.accountId),
          '*'
        );
        this.setState({
          toDate: ApiUtils.setSessionValuesForStatements(
            month,
            this.state.accountId
          ).to_date,
        });
      }
    } catch (e) {
      console.log(e);
    }
  }
  _errorModal() {
    this.setState({ errorModal: false });
  }

  backToAccountPage(e) {
    e.preventDefault();
    InternetBankingActions.navigateToWebTask(
      DigitalStatementsStore.getNavigationUrlName()
    );
  }

  closeAction() {
    this.setState({ showModalForIEPrintIssue: false });
  }
  digitalStatementsView() {
    const style = {
      width: '100vw',
    };
    const showModal = this.state.showModal;
    const accountColor = AccountsStore.getAccountType(this.state.accountId);
    const accntClass = _.get(accountColor, 'accntClass', 'account-1');
    const errorModal = this.state.errorModal;
    let accountModal;
    let displayErrorModal;
    let desktopDisplayPage;
    let mobileDisplayPage;
    let IEPrintModal = (
      <IEPrintIssueModalComponent
        content={this.props.content}
        fromPrint
        showModal={this.state.showModalForIEPrintIssue}
        closeAction={this.closeAction}
      />
    );
    if (errorModal) {
      displayErrorModal = (
        <BasicModal>
          <div className="modalb msg-popup single-msg">
            <div className="modalb-container">
              <h5>{this.props.content.digitalErrorMessage1}</h5>
              <p>
                {this.props.content.digitalErrorMessage2}
                <br />
                {this.props.content.digitalErrorMessage3}
                <br />
                {this.props.content.digitalQuoteID}
              </p>
            </div>
            <div className="modalb-footer">
              <button
                className="c-btn c-btn--default"
                onClick={this._errorModal}
              >
                Ok
              </button>
            </div>
          </div>
        </BasicModal>
      );
    }
    if (!BrowserUtils.isMobileView()) {
      if (showModal) {
        accountModal = (
          <DigitalStatementsHelpModal
            {...this.props}
            helpModal={this.helpModal}
          />
        );
      }
      desktopDisplayPage = (
        <div>
          {displayErrorModal}

          <Helmet title="Digital Statements" />

          <div className="main-container">
            <div
              className={`${accntClass} financial-stories2 statement-landing`}
            >
              <DigitalStatementsHeader
                {...this.props}
                accountId={this.state.accountId}
                helpModal={this.helpModal}
                getStatementsForSelectedMonth={
                  this.getStatementsForSelectedMonth
                }
                printStatements={this.printStatements}
                navigationUrl={this.state.navigationUrl}
              />
              {accountModal}
              <div className="statement-container" style={style}>
                <iframe
                  title="Digital Statements"
                  id="statements"
                  width="95%"
                  height="100%"
                  frameBorder="0"
                  src={envConfig.digitalStatementsUrl}
                />
              </div>
              {UserManagementStore.isBusinessUser() && (
                <div className="financial-stories2__chat ">
                  <div className="c-slab">
                    <GenericChatComponent
                      content={getChatContent(this.props.content)}
                    />
                  </div>
                </div>
              )}
            </div>
            {IEPrintModal}
          </div>
        </div>
      );
    } else {
      if (showModal) {
        mobileDisplayPage = (
          <DigitalStatementsHelpModal
            {...this.props}
            helpModal={this.helpModal}
          />
        );
      } else {
        mobileDisplayPage = (
          <div>
            {displayErrorModal}
            <div
              className={`${accntClass} financial-stories2 statement-landing`}
            >
              <DigitalStatementsHeader
                {...this.props}
                accountId={this.state.accountId}
                helpModal={this.helpModal}
                getStatementsForSelectedMonth={
                  this.getStatementsForSelectedMonth
                }
                printStatements={this.printStatements}
              />
              <div className="statement-container" style={style}>
                <iframe
                  title="Digital Statements"
                  id="statements"
                  width="100%"
                  height="100%"
                  src={envConfig.digitalStatementsUrl}
                />
              </div>
              <div className="financial-stories2__chat">
                <GenericChatComponent
                  content={getChatContent(this.props.content)}
                />
              </div>
            </div>
            {IEPrintModal}
          </div>
        );
      }
    }
    return BrowserUtils.isMobileView() ? (
      <div className="b container-fluid-full scrollable">
        {mobileDisplayPage}
      </div>
    ) : (
      <div className="b container-fluid-full scrollable">
        {desktopDisplayPage}
      </div>
    );
  }
  helpModal(booleanValue) {
    this.setState({ showModal: booleanValue }, () => {});
    BrowserUtils.isTabletView() &&
      !booleanValue &&
      setTimeout(() => {
        this.getStatementsForSelectedMonth(0);
      }, 3000);
  }
  printStatements() {
    if (BrowserUtils.isIEOrEdgeBrowser()) {
      this.setState({ showModalForIEPrintIssue: true });
    } else {
      const frm = document.getElementById('statements').contentWindow;
      frm.focus(); // focus on contentWindow is needed on some ie versions
      document.title = this.getPDFName();
      frm.postMessage('print', '*');
    }
  }
  render() {
    return (
      <BioCatchContext context={VIEW_PAYMENT_DETAILS_CONTEXT}>
        <OrientationSwitch
          backToAccountPage={this.backToAccountPage}
          view={this.digitalStatementsView}
        />
      </BioCatchContext>
    );
  }
}

DigitalStatements.propTypes = {
  content: PropTypes.object,
};

export default RequiresAuthenticatedUser(DigitalStatements);
